const SalesTiering = ({ shouldShowTiering }: { shouldShowTiering: boolean }) => {
  if (!shouldShowTiering) {
    return null;
  }

  return (
    <div className="d-flex justify-content-center  w-100 mt-4px">
      <span
        className="badge rounded-pill badge-secondary fs-12"
        style={{ paddingTop: '2px', paddingBottom: '2px', bottom: '2px' }}
        data-e2e="sales-tiering"
      >
        Sales tiering
      </span>
    </div>
  );
};

export default SalesTiering;
